/**
 * Tone colours for the FileCard error variant, on the legacy `validation-*`
 * tier. Extracted from `file-card-error.tsx` so the stable and experimental
 * sets sit side by side and a reviewer can diff them role for role.
 *
 * Layout, size and neutral classes stay inline in the component — only the
 * tone colours differ between the two tiers.
 */
export const fileCardErrorToneClasses = {
  /** The card's outer edge — the thing that says "this upload failed". */
  container: 'border-validation-destructive',
  /** Tinted square behind the alert glyph. */
  iconFrame: 'bg-validation-destructive/10',
  /** The alert glyph itself. */
  icon: 'text-validation-destructive',
  /** "PDF · Failed" supporting line. */
  meta: 'text-validation-destructive',
} as const;
